import { getWarehouses } from 'containers/Warehouses/warehousesSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useTranslation from 'hooks/useTranslation'
import { Signature } from './SignAgreementPopup'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import React, { useState } from 'react'
import Contract from './Contract'

interface SignContractPopupProps {
  contractGroupId?: string
  contractPdf: string
  /** Podgląd umowy bez podpisywania (np. z podsumowania koszyka) */
  readOnly?: boolean
  /** Podgląd wzoru umowy zamiast umowy wygenerowanej dla koszyka */
  isTemplate?: boolean
}

const SignContractPopup: React.FC<SignContractPopupProps> = ({ contractGroupId = '', contractPdf, readOnly = false, isTemplate = false }) => {
  const [signature, setSignature] = useState<false | Signature>(false)
  const clientId = useReduxSelector(selectUserId)
  const { t } = useTranslation('contract')

  const { goBack } = useHistory()
  const dispatch = useReduxDispatch()

  if (readOnly) {
    return (
      <Popup>
        <Contract
          readOnly
          outsideCart
          title={<div className='popup__title'>
            <div>{t(isTemplate ? 'agreementTemplate' : 'rentalAgreement')}</div>
          </div>}
          contractPdf={contractPdf}
          contractGroupId={contractGroupId}
          modalKey='contractPreview_subModal'
          callback={goBack}
        />
      </Popup>
    )
  }

  return (
    <Popup>
      <Contract
        outsideCart
        signature={signature}
        contractPdf={contractPdf}
        contractGroupId={contractGroupId}
        modalKey='signContract_subModal'
        signAgreementCallback={setSignature}
        callback={() => {
          goBack()
          dispatch(getWarehouses(clientId))
        }}
      />
    </Popup>
  )
}

export default SignContractPopup
